module.exports = "/_next/static/images/washington-e7dafd9636bc43998d85657ff36c5056.svg";